export const PARTNER_ROUTE_PREFIX = "/partners";

export const PARTNER_ROUTE_PATHS = {
  configs: { path: "*", to: PARTNER_ROUTE_PREFIX },
  ssoOAuthClient: { path: "sso", to: `${PARTNER_ROUTE_PREFIX}/sso` },
  ssoOAuthRedirect: { path: "sso-oauth-redirect", to: `${PARTNER_ROUTE_PREFIX}/sso-oauth-redirect` },
};
